<template>
  <div>
    <portal to="nav-bar">
      <nav-back-to-list />
    </portal>
    <async-component :params="id" :asyncFunction="loadState" #default="{ loading, error }">
      <content-spinner v-if="loading" class="ma3"/>
      <div v-else-if="error" class="ma3">Ошибка: {{ error }}</div>
      <div v-else class="mb7">
        <cross-entities-links entityCode='order' :entityId="id"/>
        <div class="entity-card">

          <div class="header-layout mh3 mh4-l mv3">
            <div class="header-section">
              <h2 class="f3 ttu ma0 pa0 fw3 text-primary">
                <span>Заказ</span>
                <span class="ml3" title="Идентификатор заказа"><span class="text-secondary">id</span> {{ id }}</span>
              </h2>
              <h1 class="ma0 pa0 f5">
                <span class="text-primary db b ttu lh-copy">{{ state.title.value }}</span>
                <span class="text-primary fw5 db mt2"><span class="text-secondary fw4">№</span> {{ state.number.value }}</span>
              </h1>
            </div>
            <div class="header-section header-section-right">
              <h2 class="f5 ttu ma0 pa0 fw3 text-accent">
                <span class="text-line-2">
                  {{ status_by_code(state.status_code.value).title }}
                </span>
              </h2>
              <ul class="list ma0 pa0">
                <li v-for="(action, index) in statusAction" :key="index" class="mb2">
                  <a href="#" class="link dim ma0 pa0 blue underline" @click.prevent="statusActionSelected(action)">
                    {{ action.title }}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <entity-menu :items="menu" v-model="menuSelection"/>
          <keep-alive>
            <component :is="menu[menuSelection].component"
              :id='id'
              :out="out"
              :state="state"
              :updateState="updateState"
              :journalContext="journalContext"
              class="bg-white"
            />
          </keep-alive>

        </div>
      </div>
    </async-component>
  </div>
</template>

<script>
import NavBackToList from '@/components/common/NavBackToList.vue'
import AsyncComponent from '@/components/AsyncComponent.vue'
import ContentSpinner from '@/components/common/ContentSpinner.vue'
import CrossEntitiesLinks from '@/components/common/CrossEntitiesLinks.vue'
import EntityMenu from '@/components/common/EntityMenu.vue'
import CardDetails from '@/components/orders/CardDetails.vue'
import Journal from '@/components/common/Journal.vue'
import DropdownButton from '@/components/ui/DropdownButton.vue'
import { DataService } from '@/services/DataService.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    NavBackToList,
    AsyncComponent,
    ContentSpinner,
    CrossEntitiesLinks,
    EntityMenu,
    CardDetails,
    Journal,
    DropdownButton
  },
  props: {
    id: { type: Number },
    params: { type: Object }
  },
  computed: {
    ...mapGetters('user', ['user']),
    ...mapGetters('order', ['status_by_code']),
    menu () {
      const items = [{
        section: 'base', name: 'Условия', component: 'CardDetails'
      }, {
        section: 'journal', name: 'Журнал', component: 'Journal'
      }]
      return this.out ? items : items.filter(i => i.component !== 'Journal')
    },
    menuSelection: {
      get () {
        const idx = this.menu.findIndex((m) => (this.params.section || 'base') === m.section)
        return idx > -1 ? idx : 0
      },
      set (idx) {
        this.$router.push({ name: 'order_card', params: { id: this.id }, query: { section: this.menu[idx].section } })
      }
    },
    statusAction () {
      const transitions = this.state.status_code.possible_values
      if (Array.isArray(transitions)) {
        return transitions.map(code => {
          return {
            action: code,
            title: this.status_by_code(code).action,
            enabled: true
          }
        })
      } else {
        return []
      }
    },
    out () {
      return this.state.company_id.value === this.user.companyId
    }
  },
  data () {
    return {
      orderState: [],
      state: null,
      counteragent: null,
      procedure: null,
      loadState: async () => {
        return DataService.getOrderState({ id: this.id })
          .then(({ fields }) => {
            this.mergeWithState(fields)
          })
          .catch((error) => {
            console.log('Order loadState error', error)
          })
      },
      updateState: async (field, value) => {
        const updatedField = { ...this.$lo.cloneDeep(field), value: value }
        return DataService.updateOrderState({ id: this.id, field: JSON.stringify(updatedField) })
          .then(({ fields }) => {
            this.mergeWithState(fields)
          })
      },
      journalContext: {
        cardLinkName: null,
        statusByCode: (code) => this.status_by_code(code),
        loadLogsJournal: async () => {
          return DataService.getOrderLogs({ filter: { orderId: this.id } })
            .then(({ data: { order_logs: { items } } }) => {
              return items
            })
        }
      },
      statusActionInProgress: false
    }
  },
  methods: {
    statusActionSelected (a) {
      this.statusActionInProgress = true
      this.updateState(this.state.status_code, a.action).finally(() => {
        this.statusActionInProgress = false
      })
    },
    mergeWithState (fields) {
      this.state = fields.reduce((acc, f) => ({ ...acc, [f.spec.name]: f }), {})
      // TODO: подумать тут что делать...
      // задача этого метода - объединить пришедшие с сервера поля с уже имеющимися
      // если значение пришедшего поля не изменилось по отношению к имеющемуся, то
      // такое поле НЕ заменяем.
      // Таким обращом, если у локального поля был список ошибок и с сервера пришло это же поле без изменений,
      // то список ошибок останется, а не исчезает с обновлением, которое, возможно, было связано с другим полем...
    }
  }
}
</script>

<style lang="scss" scoped>
.header-layout {
  display: grid;
  grid-template-columns: 2.5fr 1fr;
  grid-template-rows: auto;
  column-gap: 1rem;
}
.header-section {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: 50px minmax(80px, auto);
}
.header-section-right {
  justify-content: left;
}
.header-delimeter {
  border-top-style: solid;
  border-top-width: .25rem;
  border-color: #BCCCDC;
}
.details-layout {
  overflow: hidden;
}
</style>
